import React from 'react';

import Modal from 'antd/es/modal/Modal';

import SliderAreaVet from '@app/components/UI/Slider/SliderAreaVet';
import '@app/scss/components/area.scss';

const ModalAreaVet = ({
	vet,
	visible,
	onOk,
	onCancel,
}) => {
	return (
		<Modal open={visible} footer={false} onCancel={onCancel} wrapClassName="modal-wrap" className="modal-area-vet">
			<SliderAreaVet vet={vet} key={vet.id} />
		</Modal>
	);
};

export default ModalAreaVet;
